// extracted by mini-css-extract-plugin
export var arrowUp = "styles-module--arrowUp--12e19";
export var circleButton = "styles-module--circleButton--bc515";